import {
  REORDER_PAUTA_LIST,
  REORDER_PAUTA_LIST_LOADING,
  REORDER_PAUTA_SET_EVENT,
  REORDER_PAUTA_REQUEST,
  REORDER_PAUTA_INITIAL_LIST,
} from './ReorderPautaActions';

export interface IProps {
  eventId: number | null;
  items: any[];
  itemsLoading: boolean;
  initialState: any[];
  request: {
    eventId: number | null;
    agendaIds: Number[];
  };
}

export const INITIAL_STATE: IProps = {
  eventId: null,
  items: [],
  itemsLoading: true,
  initialState: [],
  request: {
    eventId: null,
    agendaIds: [],
  },
};

export default function ComputeVotesReducer(
  state: IProps,
  action: { type: any; payload?: any }
) {
  const { type, payload } = action;

  switch (type) {
    case REORDER_PAUTA_SET_EVENT:
      return { ...state, eventId: payload };
    case REORDER_PAUTA_LIST:
      return { ...state, items: payload };
    case REORDER_PAUTA_INITIAL_LIST:
      return { ...state, initialState: payload };
    case REORDER_PAUTA_LIST_LOADING:
      return { ...state, itemsLoading: payload };
    case REORDER_PAUTA_REQUEST:
      return { ...state, request: { ...state.request, ...payload } };
    default:
      return state;
  }
}
